"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatefulIterator = void 0;
class StatefulIterator {
    constructor(iterator) {
        this.iterator = iterator;
        this.currentResult = iterator.next();
    }
    current() {
        return this.currentResult.value;
    }
    next() {
        this.currentResult = this.iterator.next();
        return !this.done;
    }
    get done() {
        return Boolean(this.currentResult.done);
    }
    updateCurrent(value) {
        this.currentResult.value = value;
    }
}
exports.StatefulIterator = StatefulIterator;
//# sourceMappingURL=Iterator.js.map